import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination,
  Stack,
  MenuItem,
  Select,
  FormControl,
  Box,
  InputLabel,
  useTheme,
} from "@mui/material";
import "../style/table.scss";
import SortIcon from "@mui/icons-material/Sort";
import DownloadIcon from "@mui/icons-material/Download";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import { format } from "date-fns";

const TableFTP = ({
  data,
  handleRowClick,
  handleCompare,
  handleSort,
  CelluleUrlSite,
  getInfoThemeActif,
  handleDownloadExcel,
  role,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const isOnet = role === "onet";
  const isCompass = role === "compass";

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };
  const handleChangeItemsPerPage = (event) => {
  setItemsPerPage(event.target.value);
  setCurrentPage(1);
  };


  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

    return (
      <TableContainer component={Paper}  sx={{borderRadius: 2,borderTopLeftRadius: 0, overflow: 'hidden', boxShadow:2, height:"50%" }}> 
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <a
                  type="button"
                  onClick={handleDownloadExcel}
                  style={{
                    color: isDark ? 'white' : 'black',
                    position: "relative",
                    top: "10px",
                    cursor:"pointer"
                  }}
                  >
                    <DownloadIcon></DownloadIcon>
              </a>
            </TableCell>
            <TableCell
              onClick={() => handleSort("name")}
              style={{ cursor: "pointer" }}
              align="left"
            >
              Site
              <SortIcon
                style={{
                  paddingLeft: "5px",
                  position: "relative",
                  top: "5px",
                }}
              />
            </TableCell>
            <TableCell align="center">Instance</TableCell>
            <TableCell align="center" style={{ fontWeight: "bold" }}>
              Wordpress
            </TableCell>
              <TableCell align="center" style={{ fontWeight: "bold" }}>
                PHP Version 
              </TableCell>
            {role === 'admin' && (
              <>
                <TableCell
                  onClick={() => handleSort("date_input")}
                  style={{ cursor: "pointer" }}
                >
                  Dernière intervention
                  <SortIcon
                    style={{
                      paddingLeft: "5px",
                      position: "relative",
                      top: "5px",
                    }}
                  />
                </TableCell>
              </>
            )}
            <TableCell>Note d'intervention</TableCell>
            {/* {role === 'admin' && (
              <TableCell align="center">Date Fichier FTP</TableCell>
            )} */}
          </TableRow>
        </TableHead>
        <TableBody>
          {currentItems.map((item, index) => (
            <TableRow
              key={item.content.id}
              sx={{
                backgroundColor: index % 2 === 0
                  ? theme.palette.background.alternate
                  : theme.palette.background.paper,
                '&:hover': {
                  backgroundColor: isDark
                    ? 'rgba(255, 255, 255, 0.1)'
                    : 'rgba(0, 0, 0, 0.04)',
                },
                cursor: 'pointer',
              }}
              onClick={() => handleRowClick(indexOfFirstItem+index)} // Donner l'index de l'item avant d'avoir été filtré
            >
              <TableCell sx={{ width: 80, textAlign: "center" }} >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    gap:2,
                    alignItems: "center",
                    lineHeight: 0,
                  }}
                >
                  <CelluleUrlSite siteUrl={item.content.siteUrl} />
                  {(item.content.environnement?.toLowerCase() === "prd" || item.content.environnement?.toLowerCase() === "rec")  && (
                  <a
                      type="button"
                      style={{cursor:"pointer"}}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleCompare(indexOfFirstItem+index);
                      }}
                    >
                      <CompareArrowsIcon />
                  </a>
                  )}
                </Box>
              </TableCell>
              <TableCell>
                <span
                  style={{
                    cursor: "pointer",
                    fontWeight: "bold",
                  }}
                >
                  {item.content.name}
                </span>
              </TableCell>
              <TableCell align="center">{item.content.environnement}</TableCell>
              <TableCell align="center" style={{ fontWeight: "bold" }}>
                {item.content.wp_version}
              </TableCell>
              <TableCell align="center" style={{ fontWeight: "bold" }}>
                {item.content.php_version || "N/A"}
              </TableCell>
              {role === 'admin' && (
                <>
                  <TableCell>
                    {format(new Date(item.content.date_input), "dd/MM/yyyy")}
                  </TableCell>
                </>
              )}
              <TableCell>{item.content.text_input}</TableCell>
              {/* {role === 'admin' && (
                <TableCell align="center">
                  {format(new Date(item.content.dateGen), "dd/MM/yyyy")}
                </TableCell>
              )} */}
            </TableRow>
          ))}
          <TableRow>
            <TableCell colSpan={9} align="center">
              <Stack
                spacing={2}
                direction="row"
                justifyContent="center"
                alignItems="center"
              >
              <FormControl variant="outlined" size="small">
                <InputLabel  sx={{
                              color: isDark ? theme.palette.text.primary : 'black',
                              '&.Mui-focused': {
                                color: isDark ? theme.palette.text.primary : 'black',
                              },
                            }} id="items-per-page-label">Sites</InputLabel>
                <Select
                  labelId="items-per-page-label"
                  value={itemsPerPage}
                  label="Sites"
                  onChange={handleChangeItemsPerPage}
                  sx={{
                    borderRadius: 2,
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: isOnet
                        ? '#06305C'
                        : isCompass
                          ? '#c4ac66'
                          : isDark
                            ? 'rgba(255, 255, 255, 0.23)'
                            : '#F7E900',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: isOnet ? '#06305C' : isCompass ? '#c4ac66' : '#F7E900',
                    },
                  }}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        '& .MuiMenuItem-root:hover': {
                          backgroundColor: isOnet
                            ? 'rgba(6, 48, 92, 0.08)'
                            : isCompass
                              ? 'rgba(196, 172, 102, 0.08)'
                              : isDark
                                ? 'rgba(255, 255, 255, 0.08)'
                                : 'rgba(247, 233, 0, 0.08)',
                        },
                        '& .MuiMenuItem-root.Mui-selected': {
                          backgroundColor: isOnet
                            ? 'rgba(6, 48, 92, 0.12)'
                            : isCompass
                              ? 'rgba(196, 172, 102, 0.12)'
                              : 'rgba(247, 233, 0, 0.12)',
                        },
                        '& .MuiMenuItem-root.Mui-selected:hover': {
                          backgroundColor: isOnet
                            ? 'rgba(6, 48, 92, 0.16)'
                            : isCompass
                              ? 'rgba(196, 172, 102, 0.16)'
                              : isDark
                                ? 'rgba(255, 255, 255, 0.12)'
                                : 'rgba(247, 233, 0, 0.16)',
                        },
                      },
                    },
                  }}
                >
                  <MenuItem
                    value={5}
                    sx={{
                      '&.Mui-selected': {
                        backgroundColor: isOnet
                          ? 'rgba(6, 48, 92, 0.12) !important'
                          : isCompass
                            ? 'rgba(196, 172, 102, 0.12) !important'
                            : 'rgba(247, 233, 0, 0.12) !important',
                      },
                      '&.Mui-selected:hover': {
                        backgroundColor: isOnet
                          ? 'rgba(6, 48, 92, 0.16) !important'
                          : isCompass
                            ? 'rgba(196, 172, 102, 0.16) !important'
                            : isDark
                              ? 'rgba(255, 255, 255, 0.12) !important'
                              : 'rgba(247, 233, 0, 0.16) !important',
                      },
                    }}
                  >
                    5
                  </MenuItem>
                  <MenuItem
                    value={10}
                    sx={{
                      '&.Mui-selected': {
                        backgroundColor: isOnet
                          ? 'rgba(6, 48, 92, 0.12) !important'
                          : isCompass
                            ? 'rgba(196, 172, 102, 0.12) !important'
                            : 'rgba(247, 233, 0, 0.12) !important',
                      },
                      '&.Mui-selected:hover': {
                        backgroundColor: isOnet
                          ? 'rgba(6, 48, 92, 0.16) !important'
                          : isCompass
                            ? 'rgba(196, 172, 102, 0.16) !important'
                            : isDark
                              ? 'rgba(255, 255, 255, 0.12) !important'
                              : 'rgba(247, 233, 0, 0.16) !important',
                      },
                    }}
                  >
                    10
                  </MenuItem>
                  <MenuItem
                    value={50}
                    sx={{
                      '&.Mui-selected': {
                        backgroundColor: isOnet
                          ? 'rgba(6, 48, 92, 0.12) !important'
                          : isCompass
                            ? 'rgba(196, 172, 102, 0.12) !important'
                            : 'rgba(247, 233, 0, 0.12) !important',
                      },
                      '&.Mui-selected:hover': {
                        backgroundColor: isOnet
                          ? 'rgba(6, 48, 92, 0.16) !important'
                          : isCompass
                            ? 'rgba(196, 172, 102, 0.16) !important'
                            : isDark
                              ? 'rgba(255, 255, 255, 0.12) !important'
                              : 'rgba(247, 233, 0, 0.16) !important',
                      },
                    }}
                  >
                    50
                  </MenuItem>

                </Select>
              </FormControl>
                <Pagination
                  count={Math.ceil(data.length / itemsPerPage)}
                  page={currentPage}
                  onChange={handleChangePage}
                  variant="outlined"
                  sx={{
                    "& .MuiPaginationItem-root": {
                      backgroundColor: isOnet
                        ? (isDark ? theme.palette.background.paper : '')
                        : (isDark ? theme.palette.background.paper : "white"),
                      color: isDark ? theme.palette.text.primary : "black",
                      "&.Mui-selected": {
                        backgroundColor: isOnet ? '#06305C' : isCompass ? '#c4ac66' : "rgba(247, 233, 0, 0.4)",
                        border: isOnet
                          ? "1px solid"
                          : `1px solid ${isDark ? 'rgba(255, 255, 255, 0.23)' : 'rgba(0, 0, 0, 0.23)'}`,
                        color: isOnet ? "white" : isCompass ? "white" : (isDark ? "white" : "black"),
                      },
                      "&:hover": {
                        backgroundColor: isOnet
                          ? '#06305C'
                          : isCompass
                            ? '#c4ac66'
                            : (isDark ? "rgba(247, 233, 0, 0.2)" : "rgba(247, 233, 0, 0.4)"),
                        color: isOnet
                          ? "white"
                          : isCompass
                            ? "white"
                            : (isDark ? "white" : "rgba(0, 0, 0, 0.23)"),
                        border: isOnet
                          ? "1px solid"
                          : `1px solid ${isDark ? 'rgba(255, 255, 255, 0.23)' : 'rgba(0, 0, 0, 0.23)'}`,
                      },
                    },
                  }}
                />
              </Stack>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableFTP;
